import { CardVariant } from '@/components/card/types';
import { DEFAULT_DYNAMIC_CAROUSEL_COLUMN_SPAN } from '@/components/dynamic-carousel/types';
import { useGridContext } from '@/hooks/use-global-grid-context';
import { MaterialBreakpointType } from '@/providers/global-grid-provider';

export const DYNAMIC_CAROUSEL_COLUMN_SPAN_BY_VARIANT_BREAKPOINT: Partial<
    Record<CardVariant, number | Record<MaterialBreakpointType, number>>
> = {
    [CardVariant.CarouselSquare]: {
        extraExtraLarge: 4,
        extraLarge: 3,
        large: 3,
        expanded: 3,
        medium: 3,
        compact: 3,
    },
    [CardVariant.Carousel]: {
        extraExtraLarge: 4,
        extraLarge: 4,
        large: 4,
        expanded: 4,
        // Must be 5, not 6. GlobalGridItem short-circuits when span === columns (6 at medium),
        // skipping convertColumnSpanByBreakpoint and rendering full-width instead of 2 cards/row.
        // See: https://calmdotcom.atlassian.net/browse/EVE-12003
        medium: 5,
        compact: 6,
    },
};

export function useDynamicCarouselCardVariantColumnSpan(
    cardVariant: CardVariant | undefined
): number {
    const { currentMaterialBreakpoint } = useGridContext();
    if (!cardVariant) return DEFAULT_DYNAMIC_CAROUSEL_COLUMN_SPAN;

    const columnSpanByBreakpoint =
        DYNAMIC_CAROUSEL_COLUMN_SPAN_BY_VARIANT_BREAKPOINT[cardVariant] ??
        DEFAULT_DYNAMIC_CAROUSEL_COLUMN_SPAN;

    if (typeof columnSpanByBreakpoint === 'number')
        return columnSpanByBreakpoint;

    return columnSpanByBreakpoint[currentMaterialBreakpoint];
}
